var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yes-no-details-input',_vm._g(_vm._b({attrs:{"detailsType":"number","detailsValidation":['required', 'number']}},'yes-no-details-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }